import React from "react";
import Select from "react-select";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Row, Col, Label } from "reactstrap";

const normalizeArray = (val) => {
  if (!val) return [];
  if (Array.isArray(val)) return val;
  if (typeof val === "string") return val.split(",").map((s) => s.trim()).filter(Boolean);
  return [];
};

const LeadFilters = ({
  isOpen,
  toggle,
  filters,
  setFilters,
  stages = [],
  projects = [],
  forms = [],
  users = [],
  pages = [],
  hideAssignedToFilter = false,
}) => {
  const handle = (key, val) => {
    setFilters((p) => ({
      ...p,
      [key]: val,
      page: 1,
    }));
  };

  const selectedStages = normalizeArray(filters.stage);
  const selectedProjects = normalizeArray(filters.projectId);
  const selectedForms = normalizeArray(filters.formId);
  const selectedPages = normalizeArray(filters.pageId);
  const selectedUsers = normalizeArray(filters.assignedTo);

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="lg">
      <ModalHeader toggle={toggle}>
        Lead Filters
      </ModalHeader>

      <ModalBody>
        <Row className="g-3">
          <Col md={6}>
            <Label>Source</Label>
            <Select
              value={[
                { label: "All", value: "all" },
                { label: "Facebook", value: "facebook" },
                { label: "Google", value: "google" },
                { label: "Generic / Import", value: "generic" },
                { label: "Ai calling", value: "ai_calling" },
                { label: "Ivr calling", value: "ivr_calling" },
                { label: "RCS msg", value: "rcs_msg" },
                { label: "Whatsapp", value: "whatsapp" },
              ].find((s) => s.value === filters.source)}
              onChange={(e) => handle("source", e?.value || "all")}
              options={[
                { label: "All", value: "all" },
                { label: "Facebook", value: "facebook" },
                { label: "Google", value: "google" },
                { label: "Generic / Import", value: "generic" },
                { label: "Ai calling", value: "ai_calling" },
                { label: "Ivr calling", value: "ivr_calling" },
                { label: "RCS msg", value: "rcs_msg" },
                { label: "Whatsapp", value: "whatsapp" },
              ]}
            />
          </Col>

          <Col md={6}>
            <Label>Stage</Label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              placeholder="Select Stage..."
              value={stages
                .filter((s) => selectedStages.includes(s._id))
                .map((s) => ({ label: s.name, value: s._id }))}
              onChange={(selected) =>
                handle("stage", selected ? selected.map((x) => x.value) : [])
              }
              options={stages.map((s) => ({
                label: s.name,
                value: s._id,
              }))}
              isClearable
            />
          </Col>

          <Col md={6}>
            <Label>Project</Label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              placeholder="Select Project..."
              value={projects
                .filter((p) => selectedProjects.includes(p._id))
                .map((p) => ({ label: p.projectName, value: p._id }))}
              onChange={(selected) =>
                handle("projectId", selected ? selected.map((x) => x.value) : [])
              }
              options={projects.map((p) => ({
                label: p.projectName,
                value: p._id,
              }))}
              isClearable
            />
          </Col>

          <Col md={6}>
            <Label>Form</Label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              placeholder="Select Form..."
              value={forms
                .filter((f) => selectedForms.includes(f.formId))
                .map((f) => ({ label: f.formName, value: f.formId }))}
              onChange={(selected) =>
                handle("formId", selected ? selected.map((x) => x.value) : [])
              }
              options={forms.map((f) => ({
                label: f.formName,
                value: f.formId,
              }))}
              isClearable
            />
          </Col>

          <Col md={6}>
            <Label>Page</Label>
            <Select
              isMulti
              closeMenuOnSelect={false}
              placeholder="Select Page..."
              value={pages
                .filter((p) => selectedPages.includes(p.refId))
                .map((p) => ({ label: p.name, value: p.refId }))}
              onChange={(selected) =>
                handle("pageId", selected ? selected.map((x) => x.value) : [])
              }
              options={pages.map((p) => ({
                label: p.name,
                value: p.refId,
              }))}
              isClearable
            />
          </Col>

          {!hideAssignedToFilter && (
            <Col md={6}>
              <Label>Assigned User</Label>
              <Select
                isMulti
                closeMenuOnSelect={false}
                placeholder="Select User..."
                value={users
                  .filter((u) => selectedUsers.includes(u._id))
                  .map((u) => {
                    const name = `${u.firstName || ""} ${u.lastName || ""}`.trim();
                    const des =
                      typeof u.designationId === "object" && u.designationId?.title
                        ? u.designationId.title
                        : u.designation || "";
                    const details = [u.email, des].filter(Boolean).join(" - ");
                    return {
                      label: details ? `${name} (${details})` : name,
                      value: u._id,
                    };
                  })}
                onChange={(selected) =>
                  handle("assignedTo", selected ? selected.map((x) => x.value) : [])
                }
                options={users.map((u) => {
                  const name = `${u.firstName || ""} ${u.lastName || ""}`.trim();
                  const des =
                    typeof u.designationId === "object" && u.designationId?.title
                      ? u.designationId.title
                      : u.designation || "";
                  const details = [u.email, des].filter(Boolean).join(" - ");
                  return {
                    label: details ? `${name} (${details})` : name,
                    value: u._id,
                  };
                })}
                isClearable
              />
            </Col>
          )}

          <Col md={6}>
            <Label>Sort By</Label>
            <Select
              value={{
                label: filters.sortBy,
                value: filters.sortBy,
              }}
              onChange={(e) => handle("sortBy", e?.value)}
              options={[
                { label: "Name", value: "name" },
                { label: "Email", value: "email" },
                { label: "Phone", value: "phone" },
                { label: "Created Date", value: "createdTime" },
              ]}
            />
          </Col>

          <Col md={6}>
            <Label>Sort Order</Label>
            <Select
              value={{
                label: filters.sortOrder,
                value: filters.sortOrder,
              }}
              onChange={(e) => handle("sortOrder", e?.value)}
              options={[
                { label: "Descending", value: "desc" },
                { label: "Ascending", value: "asc" },
              ]}
            />
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Button color="light" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default LeadFilters;